var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import LetterBatchPrint from '~/components/smart-collection/letter-collection/letter-batch-print.vue';
import { SmartCollectionService } from "~/services/domain-service/smart-collection.service";
import NumberRange from '~/components/common/number-range.vue';
var LetterCollection = /** @class */ (function (_super) {
    __extends(LetterCollection, _super);
    function LetterCollection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            letterBatchPrint: false,
        };
        _this.model = {
            caseNumber: '',
            personalName: '',
            currentCollectorRealName: '',
            overduePeriod: '',
            caseMoney: { min: '', max: '' }
        };
        return _this;
    }
    LetterCollection.prototype.refreshData = function () {
        var _this = this;
        this.smartCollectionService.getAllCollectionCaseInfo(this.model, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 重置
     */
    LetterCollection.prototype.handleResetForm = function () {
        this.model.caseMoney = { min: '', max: '' };
    };
    LetterCollection.prototype.mounted = function () {
        this.refreshData();
    };
    LetterCollection.prototype.LetterBatchPrintClick = function () {
        if (this.selectionList.length === 0) {
            this.$message.info('请先选择案件');
            return;
        }
        this.dialog.letterBatchPrint = true;
    };
    __decorate([
        Dependencies(PageService)
    ], LetterCollection.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LetterCollection.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SmartCollectionService)
    ], LetterCollection.prototype, "smartCollectionService", void 0);
    LetterCollection = __decorate([
        Auth(2203),
        Layout("workspace"),
        Component({
            components: {
                LetterBatchPrint: LetterBatchPrint,
                NumberRange: NumberRange,
            }
        })
    ], LetterCollection);
    return LetterCollection;
}(Vue));
export default LetterCollection;
